import React, { forwardRef } from 'react';

import Padlock from '@/assets/padlock.svg?react';
import cn from '@/utils/cn';

import { Input } from './Input';
import { PasswordInputProps } from './Input.types';
import { useLingui } from '@lingui/react';

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ onBlur, wrapperProps, ...props }, ref) => {
    // TODO: move to PasswordInput component when it's merged

    const { i18n } = useLingui();

    return (
      <div
        {...wrapperProps}
        className={cn(
          'space-y-1.5 text-dark-gray-500 md:space-y-2',
          wrapperProps?.className
        )}
        aria-label="password-input"
      >
        <h5 className="flex items-center gap-2">
          <Padlock className="size-4 flex-none" />
          {i18n.t(
            'Plik może być zabezpieczony – jeśli masz hasło, wpisz je poniżej'
          )}
        </h5>

        <Input
          {...props}
          type="text"
          label={'Hasło'}
          onBlur={onBlur}
          ref={ref}
        />
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
